/**
 * Draft notes queued for a supplier's FIRST outreach message. Discovery's
 * "Add to my first message" writes here; the outreach composer prefills from
 * here and clears the note once the message actually sends. There is no
 * server-side draft store yet, so this is deliberately a thin, per-browser
 * localStorage seam — full drafting moves server-side with the Robbie
 * compose capability.
 */

const keyOf = (bomId: string, componentId: string, supplierName: string): string =>
  `hr.outreach-note.${bomId}.${componentId}.${supplierName.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;

export const saveOutreachNote = (
  bomId: string,
  componentId: string,
  supplierName: string,
  note: string,
): void => {
  try {
    window.localStorage.setItem(keyOf(bomId, componentId, supplierName), note);
  } catch {
    // Storage unavailable (private mode/quota) — the note simply isn't queued.
  }
};

export const readOutreachNote = (
  bomId: string,
  componentId: string,
  supplierName: string,
): string | undefined => {
  try {
    return window.localStorage.getItem(keyOf(bomId, componentId, supplierName)) ?? undefined;
  } catch {
    return undefined;
  }
};

export const clearOutreachNote = (bomId: string, componentId: string, supplierName: string): void => {
  try {
    window.localStorage.removeItem(keyOf(bomId, componentId, supplierName));
  } catch {
    // Nothing to clean up if storage is unavailable.
  }
};
